import * as React from 'react';
import { connect } from 'react-redux';
import { WHATSAPP_LIVE_CHAT } from '../../routes/routes';

class ContactUsWhatsAppBlock extends React.Component<any, any> {
    public render() {
        return (
            <>
                <div className="ssp-contact-us-whatsapp-container cursor-pointer" onClick={() => window.open(WHATSAPP_LIVE_CHAT, "_blank")}>
                    <div className="row">
                        <div className="col ssp-contact-us-whatsapp-icon-col  ssp-contact-us-whatsapp-icon-col-fnol"></div>
                        <div className="col nopa ssp-contact-us-whatsapp-text-col">
                            <p className="chat-to-us-via-whatsapp">Chat to us via WhatsApp</p>
                            <p className="get-in-touch-with-us-text">
                                Get in touch with our friendly support team via WhatsApp.&nbsp;
                                <span className="desktoponly">Click here</span>
                                <span className="ismobile">Tap here</span>
                                &nbsp;to start chatting.
                            </p>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return { }
}
export default connect(mapStateToProps, mapDispatchToProps)(ContactUsWhatsAppBlock);